"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getSxPropTypes = exports.SX_PROP_CONFIG = void 0;
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _customPropTypes = _interopRequireDefault(require("../../util/custom-prop-types"));
var SX_PROP_CONFIG = {
  alignContent: {
    proptype: [_propTypes.default.string]
  },
  alignItems: {
    proptype: [_propTypes.default.string]
  },
  alignSelf: {
    proptype: [_propTypes.default.string]
  },
  aspectRatio: {
    proptype: [_propTypes.default.string]
  },
  backgroundColor: {
    proptype: [_propTypes.default.string]
  },
  border: {
    proptype: [_propTypes.default.string]
  },
  borderColor: {
    proptype: [_propTypes.default.string],
    constituentProps: ['borderTopColor', 'borderRightColor', 'borderBottomColor', 'borderLeftColor']
  },
  borderRadius: {
    proptype: [_propTypes.default.string],
    constituentProps: ['borderTopRightRadius', 'borderTopLeftRadius', 'borderBottomRightRadius', 'borderBottomLeftRadius']
  },
  borderStyle: {
    proptype: [_propTypes.default.string]
  },
  borderWidth: {
    proptype: [_propTypes.default.string, _propTypes.default.number],
    constituentProps: ['borderTopWidth', 'borderRightWidth', 'borderBottomWidth', 'borderLeftWidth']
  },
  bottom: {
    proptype: [_propTypes.default.string, _propTypes.default.number]
  },
  boxShadow: {
    proptype: [_propTypes.default.string]
  },
  boxSizing: {
    proptype: [_propTypes.default.string]
  },
  color: {
    proptype: [_propTypes.default.string]
  },
  cursor: {
    proptype: [_propTypes.default.string]
  },
  display: {
    proptype: [_propTypes.default.string]
  },
  fill: {
    proptype: [_propTypes.default.string]
  },
  flex: {
    proptype: [_propTypes.default.string]
  },
  flexBasis: {
    proptype: [_propTypes.default.string]
  },
  flexDirection: {
    proptype: [_propTypes.default.string]
  },
  flexFlow: {
    proptype: [_propTypes.default.string]
  },
  flexGrow: {
    proptype: [_propTypes.default.string, _propTypes.default.number]
  },
  flexShrink: {
    proptype: [_propTypes.default.string, _propTypes.default.number]
  },
  flexWrap: {
    proptype: [_propTypes.default.string]
  },
  fontFamily: {
    proptype: [_propTypes.default.string]
  },
  fontSize: {
    proptype: [_propTypes.default.string]
  },
  fontStyle: {
    proptype: [_propTypes.default.string]
  },
  fontWeight: {
    proptype: [_propTypes.default.string]
  },
  gap: {
    proptype: [_propTypes.default.string, _propTypes.default.number]
  },
  grid: {
    proptype: [_propTypes.default.string]
  },
  gridArea: {
    proptype: [_propTypes.default.string]
  },
  gridAutoColumns: {
    proptype: [_propTypes.default.string]
  },
  gridAutoFlow: {
    proptype: [_propTypes.default.string]
  },
  gridAutoRows: {
    proptype: [_propTypes.default.string]
  },
  gridColumn: {
    proptype: [_propTypes.default.string]
  },
  gridColumnEnd: {
    proptype: [_propTypes.default.string]
  },
  gridColumnGap: {
    proptype: [_propTypes.default.string, _propTypes.default.number]
  },
  gridColumnStart: {
    proptype: [_propTypes.default.string]
  },
  gridGap: {
    proptype: [_propTypes.default.string, _propTypes.default.number]
  },
  gridRow: {
    proptype: [_propTypes.default.string]
  },
  gridRowEnd: {
    proptype: [_propTypes.default.string]
  },
  gridRowGap: {
    proptype: [_propTypes.default.string, _propTypes.default.number]
  },
  gridRowStart: {
    proptype: [_propTypes.default.string]
  },
  gridTemplate: {
    proptype: [_propTypes.default.string]
  },
  gridTemplateAreas: {
    proptype: [_propTypes.default.string]
  },
  gridTemplateColumns: {
    proptype: [_propTypes.default.string]
  },
  gridTemplateRows: {
    proptype: [_propTypes.default.string]
  },
  height: {
    proptype: [_propTypes.default.string]
  },
  justifyContent: {
    proptype: [_propTypes.default.string]
  },
  justifyItems: {
    proptype: [_propTypes.default.string]
  },
  justifySelf: {
    proptype: [_propTypes.default.string]
  },
  left: {
    proptype: [_propTypes.default.string, _propTypes.default.number]
  },
  lineHeight: {
    proptype: [_propTypes.default.string]
  },
  margin: {
    proptype: [_propTypes.default.string, _propTypes.default.number],
    constituentProps: ['marginTop', 'marginRight', 'marginBottom', 'marginLeft']
  },
  opacity: {
    proptype: [_propTypes.default.string, _propTypes.default.number]
  },
  order: {
    proptype: [_propTypes.default.string, _propTypes.default.number]
  },
  outline: {
    proptype: [_propTypes.default.string]
  },
  overflow: {
    proptype: [_propTypes.default.string]
  },
  padding: {
    proptype: [_propTypes.default.string, _propTypes.default.number],
    constituentProps: ['paddingTop', 'paddingRight', 'paddingBottom', 'paddingLeft']
  },
  placeContent: {
    proptype: [_propTypes.default.string]
  },
  placeItems: {
    proptype: [_propTypes.default.string]
  },
  placeSelf: {
    proptype: [_propTypes.default.string]
  },
  position: {
    proptype: [_propTypes.default.string]
  },
  right: {
    proptype: [_propTypes.default.string, _propTypes.default.number]
  },
  rowGap: {
    proptype: [_propTypes.default.string, _propTypes.default.number]
  },
  stroke: {
    proptype: [_propTypes.default.string]
  },
  textAlign: {
    proptype: [_propTypes.default.string]
  },
  textDecoration: {
    proptype: [_propTypes.default.string]
  },
  textTransform: {
    proptype: [_propTypes.default.string]
  },
  textOverflow: {
    proptype: [_propTypes.default.string]
  },
  textShadow: {
    proptype: [_propTypes.default.string]
  },
  top: {
    proptype: [_propTypes.default.string, _propTypes.default.number]
  },
  transform: {
    proptype: [_propTypes.default.string]
  },
  transformOrigin: {
    proptype: [_propTypes.default.string]
  },
  transformStyle: {
    proptype: [_propTypes.default.string]
  },
  transition: {
    proptype: [_propTypes.default.string]
  },
  transitionTiming: {
    proptype: [_propTypes.default.string]
  },
  transitionProperty: {
    proptype: [_propTypes.default.string]
  },
  transitionTimingFunction: {
    proptype: [_propTypes.default.string]
  },
  userSelect: {
    proptype: [_propTypes.default.string]
  },
  verticalAlign: {
    proptype: [_propTypes.default.string]
  },
  visibility: {
    proptype: [_propTypes.default.string]
  },
  width: {
    proptype: [_propTypes.default.string]
  },
  zIndex: {
    proptype: [_propTypes.default.string, _propTypes.default.number]
  }
};
exports.SX_PROP_CONFIG = SX_PROP_CONFIG;
var getSxPropTypes = function getSxPropTypes() {
  return Object.keys(SX_PROP_CONFIG).reduce(function (runner, current) {
    var setting = SX_PROP_CONFIG[current];
    var typeConcat = (0, _toConsumableArray2.default)(setting !== null && setting !== void 0 && setting.proptype ? setting.proptype : []);
    var attrs = {};
    var value = _customPropTypes.default.inlineMediaQuery(_propTypes.default.oneOfType((0, _toConsumableArray2.default)(typeConcat)));
    Object.defineProperty(attrs, current, {
      value: value
    });
    if (setting !== null && setting !== void 0 && setting.constituentProps && setting.constituentProps.length > 0) {
      setting.constituentProps.forEach(function (prop) {
        Object.defineProperty(attrs, prop, {
          value: value
        });
      });
    }
    return Object.keys(attrs).length > 0 ? Object.assign({}, runner, attrs) : Object.assign({}, runner);
  }, {});
};
exports.getSxPropTypes = getSxPropTypes;